module.exports = {"511025100":"重龙镇","511025102":"归德镇","511025103":"鱼溪镇","511025105":"铁佛镇","511025106":"球溪镇","511025108":"龙结镇","511025109":"罗泉镇","511025110":"发轮镇","511025112":"银山镇","511025114":"太平镇","511025116":"水南镇","511025118":"新桥镇","511025119":"明心寺镇","511025120":"双河镇","511025121":"公民镇","511025122":"龙江镇","511025123":"双龙镇","511025124":"高楼镇","511025125":"陈家镇","511025128":"孟塘镇","511025129":"马鞍镇","511025130":"狮子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511025.json
// module id = 2456
// module chunks = 0